import {WhiteBgButtonThin} from '@packages/ui';
import type {FC} from 'react';

type Props = {
  onResend: () => void;
  isResending: boolean;
};

export const AcEmailResendButton: FC<Props> = ({onResend, isResending}) => (
  <WhiteBgButtonThin
    label="認証メールを再送する"
    isPrimary={false}
    isDisabled={isResending}
    className="w-full max-w-[280px] cursor-pointer"
    as="button"
    onClick={onResend}
  />
);
